import { HttpParams } from '@angular/common/http'
import { ParamMap } from '@angular/router'
import { EXPERIENCE_API_VERSION } from '../app.config'

/*
 * Return HttpParams common to all entity hub GET requests
 */
export function getSearchHttpParams(queryParams: ParamMap | null, siteId: number, useOfp = false): HttpParams {
  let params = new HttpParams({
    fromObject: {
      version: EXPERIENCE_API_VERSION,
      tz: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles',
      site_id: siteId.toString(),
      ...(useOfp && { useOfp })
    }
  })

  const type = queryParams?.get('type')
  params = type ? params.set('type', type) : params
  const offset = queryParams?.get('offset')
  params = offset ? params.set('offset', offset) : params
  const limit = queryParams?.get('limit')
  params = limit ? params.set('limit', limit) : params
  // here we are setting the query property to the search param value
  // because we want search in the vanity url but the endpoint expects query
  const search = queryParams?.get('search')
  params = search ? params.set('query', search) : params

  return params
}
